import React, { useEffect, useState } from "react";

import { productsFaqs, productsFaqsType, faqType } from "../../data/productFaq";

import { Icon } from "../../components/Icon/Icon";
import chevronDown from "../../assets/images/chevron-down.png";

import cs from "classnames";

import { useInView } from "react-intersection-observer";

import "./Support.scss";
import hover50x60Image from "../../assets/images/Infinite60x50/60x50-hover.png";

const Support = () => {
  const [products, setProducts] = useState<productsFaqsType[]>();
  const [activeProduct, setActiveProduct] = useState<productsFaqsType>();
  const [activeQuestion, setActiveQuestion] = useState<faqType>();
  const { ref: supportTitleRef, inView: supportTitleVisibility } = useInView();
  const { ref: supportProductsRef, inView: supportProductsVisibility } =
    useInView();
  const { ref: supportFaqRef, inView: supportFaqVisibility } = useInView();

  useEffect(() => {
    setProducts(productsFaqs);
  }, []);

  useEffect(() => {
    if (products) {
      setActiveProduct(products[0]);
    }
  }, [products]);

  return (
    <div className="Support">
      <div className="Support__container">
        <div
          ref={supportTitleRef}
          className={cs(
            "Support__title",
            supportTitleVisibility && "Support__title-animation",
          )}
        >
          Support
        </div>

        <div
          ref={supportProductsRef}
          className={cs(
            "Support__products",
            supportProductsVisibility && "Support__products-animation",
          )}
        >
          {products?.map((product) => (
            <>
              <div
                className={cs(
                  "Support__product",
                  supportProductsVisibility &&
                    `Support__product-animation${product.id}`,
                  // product.id === activeProduct?.id && "Support__product-active",
                )}
                onClick={() => {
                  setActiveProduct(product);
                  setActiveQuestion({ question: "", answer: "" });
                }}
              >
                <div className="Support__product-image-container">
                  {product.id === activeProduct?.id ? (
                    <img
                      className={cs("Support__product-render")}
                      src={product.hoverImage}
                    />
                  ) : (
                    <Icon
                      alt="product"
                      icon={product.image}
                      className="Support__product-image"
                    />
                  )}
                </div>

                <div className="Support__product-name">
                  <span>{product.name}</span> {product.id}
                </div>
              </div>
              <div className="Support__product-divider"></div>
            </>
          ))}
        </div>

        <div className="Support__faq" ref={supportFaqRef}>
          {activeProduct?.faq.map((faq, index) => (
            <div
              className={cs(
                "Support__question",
                supportFaqVisibility &&
                  `Support__question-animationQuestion${index}`,
              )}
              onClick={() => {
                if (faq.question === activeQuestion?.question) {
                  setActiveQuestion({ question: "", answer: "" });
                } else {
                  setActiveQuestion(faq);
                }
              }}
            >
              <div className="Support__question-head">
                <div className="Support__question-title">{faq.question}</div>
                <img
                  className={cs(
                    "Support__question-icon",
                    faq.question === activeQuestion?.question &&
                      "Support__question-icon-isOpen",
                  )}
                  src={chevronDown}
                />
              </div>
              {faq.question === activeQuestion?.question && (
                <div className="Support__question-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Support;
